import styled, { css } from "styled-components";

import * as SwitchStyles from "../../../../components/Switch/styles";

export const Container = styled.div`
  @media (min-width: 768px) {
    height: 100%;
    overflow-y: auto;
  }
`;

export const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 2rem;
  padding: 0;

  ${SwitchStyles.Container} {
    width: 230px;
    margin-top: 0px;
  }

  @media (min-width: 768px) {
    margin-top: 3rem;
    padding: 0 2rem;
  }
`;

export const ContentForm = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  width: 100%;

  > div {
    width: 100%;
  }

  > div + div {
    margin-top: 1rem;
  }

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;

    > div {
      & + div {
        margin-top: 0rem;
      }
    }
  }
`;

export const ContentButton = styled.div`
  max-width: 280px;
  width: 100%;
  margin-top: 2rem;
`;

export const PictureTask = styled.div`
  margin-top: 1rem;
`;

export const PicturePreview = styled.div`
  height: 180px;
  width: 100%;
  margin: 0 auto;
  box-shadow: 0px 1px 2px 2px rgba(0, 0, 0, 0.1);

  img {
    height: 180px;
    width: 100%;
    object-fit: cover;
  }

  @media (min-width: 768px) {
    width: 270px;

    img {
      width: 270px;
    }
  }
`;

export const NoPicturePreview = styled.div`
  ${({ theme }) => css`
    background-image: linear-gradient(
      to bottom,
      ${theme.colors.lightGray},
      ${theme.colors.lightGray} 45%
    );
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: ${theme.colors.white};
    height: 180px;
    width: 100%;
    margin: 0 auto;

    svg {
      width: 30px;
      height: 30px;
      margin-bottom: 1rem;
    }

    p {
      font-size: 0.875rem;
    }

    @media (min-width: 768px) {
      width: 350px;
    }
  `}
`;

export const ContentCalendar = styled.div`
  margin: 1rem 0 0;

  @media (min-width: 768px) {
    margin: 1rem 0;
  }
`;

export const ControlsUploadImage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 0.5rem;
  cursor: pointer;

  div:nth-child(1) {
    box-shadow: 0px 1px 2px 2px rgba(0, 0, 0, 0.1);
    padding: 0.5rem;
    font-size: 0.75rem;
    width: 130px;
    border-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 35px;

    label {
      cursor: pointer;
    }

    input {
      display: none;
    }
  }
`;

export const RemovePicture = styled.div`
  width: 30px;
  height: 30px;
  margin-left: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.error};
  color: ${({ theme }) => theme.colors.white};
  border-radius: 50%;
  cursor: pointer;
`;
